/**
 * Cookie names used throughout the application.
 * Centralizes cookie name definitions to prevent inconsistencies and typos.
 */

/**
 * Cookie name for storing the Next.js locale preference.
 * Used for client-side locale persistence across sessions.
 */
export const NEXT_LOCALE_COOKIE = 'NEXT_LOCALE' as const

/**
 * Cookie name for storing the user's dashboard locale preference.
 * Used to sync locale preference with the backend user settings.
 */
export const DASHBOARD_LOCALE_COOKIE = 'dashboard_locale' as const

export const LOCALE_COOKIE_NAMES = [
  NEXT_LOCALE_COOKIE,
  DASHBOARD_LOCALE_COOKIE,
  'nextLocale', // Legacy cookie name
  'locale', // Fallback cookie name
] as const

export type LocaleCookieName = (typeof LOCALE_COOKIE_NAMES)[number]
